<template>
  <div class="basic-block block-hero-base" :style="styles">
    <div class="content-wrap">
      <picture>
        <source v-if="targetInfo.hero.sp" :srcset="targetInfo.hero.sp" media="(max-width:580px)">
        <source v-if="targetInfo.hero.pc" :srcset="targetInfo.hero.pc">
        <img :src="fallbackPath" :alt="targetInfo.hero.alt" width="100%">
      </picture>
      <div class="banner-wrap">
        <!-- NEWRelease -->
        <p class="banner-subtitle">【PR】New Release</p>
        <a href="https://kurenotori.jp?utm_source=uranai.tv&utm_medium=referral&utm_campaign=LO00100002"><img class="banner-yearluck-2023 maru" src="/static/img/banner/kurenotori_2.jpg"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockHero',
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  computed:{
    fallbackPath(){
      const dt = this.targetInfo.hero
      return window.innerWidth > 580
        ? (!!dt.fallback_pc ? dt.fallback_pc : dt.pc)
        : (!!dt.fallback_pc ? dt.fallback_sp : dt.sp)
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-hero-base {
  text-align: center;
  img {
    max-width: 100%;
    vertical-align: middle;
  }
  .banner-wrap{
    width: 100%;
    padding: 8px 5.333% 20px;
  }
  .banner-subtitle{
    text-align: center;
    margin-bottom: 4px;
    font-size: 20px;
    @include mq('w580') {
      font-size: 29px;
    }
  }
  .maru{
    border-radius: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockHero.vue